@if (options != null) {
  <div [class]="specificBranchTabsClass">
    @if (hasAddAndCutSpecificBranch) {
      <div [class]="getGlobalTopConnectorLineClass('top-inter-branch-connector')"></div>
      <ng-container *ngTemplateOutlet="tabsTopConnectors"></ng-container>
    }
    <app-segmented-button (selectedOption)="clickOnTab($event)"
    [options]="updatedOptions"></app-segmented-button>
    @if (hasBottomConnectors()) {
      <ng-container *ngTemplateOutlet="tabsBottomConnectors"></ng-container>
      <div [class]="getGlobalBottomConnectorLineClass('bottom-inter-branch-connector')"></div>
    }
  </div>
}

<ng-template #specificBranchButtonTemplate let-option="option">
  @if (specificTabIsInUnfinishedPath(option)) {
    <ng-container *ngTemplateOutlet="unfinishedPathTabMarker, context: {option: option}"></ng-container>
  }
</ng-template>

<ng-template #tabsBottomConnectors>
  <div class="add-and-cut-branches-connectors">
    @for (option of options; track option) {
      <div class="tab-bottom-connector">
        @if (option.isSelected) {
          <div
          [class]="getGlobalBottomConnectorLineClass('tab-bottom-connector-line')"></div>
        }
      </div>
    }
    <div [class]="getGlobalBottomConnectorLineClass('bottom-line')" [ngStyle]="bottomLineStyle()"></div>
  </div>
</ng-template>

<ng-template #tabsTopConnectors>
  <div class="add-and-cut-branches-connectors">
    <div [class]="getGlobalTopConnectorLineClass('top-line')"></div>
    @for (option of options; track option) {
      <div class="tab-top-connector">
        @if (hasTopConnector(option)) {
          <div [class]="getSpecificTabTopLineClass(option)"
            [ngClass]="{'full': hasCutButton(option.value)}">
            @if (specificTabIsUnfinishedPathOrigin(option)) {
              <div
                [class]="unfinishedPathMarkerContainerClass">
                <div [class]="getGlobalTopConnectorLineClass('unfinished-path-origin-line')"></div>
                <ng-container
                *ngTemplateOutlet="unfinishedPathLineMarker"></ng-container>
              </div>
            }
            @if (isEditMode) {
              @if (hasAddButton(option.value)) {
                <button (click)="clickAddTabOption(option.value)"
                  [attr.data-cy]="addButtonDataCy(option)"
                class="add-cut-button iwp-icon-gen_plus"></button>
              }
              @if (hasCutButton(option.value)) {
                <button (click)="clickCutTabOption(option.value)"
                  [attr.data-cy]="cutButtonDataCy(option)"
                [class]="cutButtonClass(option)"></button>
              }
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #unfinishedPathTabMarker let-option="option">
  <app-tooltip [dynamic]="false" [message]="unfinishedPathTabMarkerMessage(option)">
    <span [attr.data-cy]="'tab-' + markerType.UNFINISHED_PATH_MARKER_CLASS"
    [class]="markerType.UNFINISHED_PATH_MARKER_CLASS"></span>
  </app-tooltip>
</ng-template>

<ng-template #unfinishedPathLineMarker>
  <app-tooltip [dynamic]="false" [message]="'Unfinished path origin'">
    <span [attr.data-cy]="'line-' + markerType.UNFINISHED_PATH_MARKER_CLASS"
    [class]="markerType.UNFINISHED_PATH_MARKER_CLASS"></span>
  </app-tooltip>
</ng-template>
